import { log } from '../lib/log';

/**
 * One compact, monotonic boot timeline for diagnosing the time to first
 * usable Navi image. This deliberately records each milestone at most once:
 * React development StrictMode may mount panels twice, but that must not make
 * the startup sequence ambiguous in the console.
 */
const startedAt = typeof performance === 'undefined' ? 0 : performance.now();
const seen = new Set<string>();

export function logStartupMilestone(name: string, details = ''): void {
  if (seen.has(name)) return;
  seen.add(name);
  const elapsedMs = typeof performance === 'undefined' ? 0 : performance.now() - startedAt;
  log.info('boot', `+${elapsedMs.toFixed(1)} ms ${name}${details ? ` — ${details}` : ''}`);
  if (typeof window !== 'undefined') {
    const bootWindow = window as Window & {
      __chaosrenderBootMilestones?: Record<string, { name: string; details: string; elapsedMs: number }>;
    };
    const milestone = { name, details, elapsedMs };
    bootWindow.__chaosrenderBootMilestones = {
      ...bootWindow.__chaosrenderBootMilestones,
      [name]: milestone,
    };
    window.dispatchEvent(new CustomEvent('chaosrender:boot-milestone', { detail: milestone }));
  }
}
